import { createStore, applyMiddleware, compose, type Action } from 'redux';
import { responsiveStoreEnhancer } from 'redux-responsive';

import { fromJS } from 'immutable';

import createSagaMiddleware from 'redux-saga';
import { isSSR } from 'src/helpers/ssr';
import { getViewInitialState } from 'src/store/view/reducer';

import reducer from '../reducers';
import sagas from '../sagas';

const composeEnhancers =
  (!isSSR && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const enhancer = composeEnhancers(
  responsiveStoreEnhancer,
  applyMiddleware(...middlewares),
);

const validatePreloadedState = ({ view: { availableSearchTypes } }) => {
  if (!availableSearchTypes || availableSearchTypes.length < 1) {
    throw new Error(
      `Ошибка при валидации preloadedState стора. availableSearchTypes равно ${availableSearchTypes}`,
    );
  }
};

export const getStore = (props) => {
  const {
    isHomepage,
    isMobile,
    isIframe,
    isWidgetShown,
    isTransparent,
    isFontsBlack,
    platform,
    appName,
    orderInfo,
    availableSearchTypes,
    wlPartnerSettings,
  } = props;

  const preloadedState = {
    view: {
      isMobile,
      isIframe,
      isWidgetShown,
      isTransparent,
      isFontsBlack,
      platform,
      appName,
      orderInfo,
      isHomepage,
      availableSearchTypes,
      wlPartnerSettings,
      ...getViewInitialState(),
    },
  };

  validatePreloadedState(preloadedState);

  // Иначе ругается на unknown, когда пытаюсь из view isWhitelabel достать в HeaderApp.tsx

  const store = createStore<any, Action<any>, any, any>(
    reducer,
    fromJS(preloadedState),
    enhancer,
  );

  sagaMiddleware.run(sagas);
  return store;
};
